const ADMIN_USERNAMES = new Set(["admin", "lipek"]);

export const canAccessAdminPanel = (user) => {
  const username = user?.username;
  if (typeof username !== "string") {
    return false;
  }

  return ADMIN_USERNAMES.has(username.trim().toLowerCase());
};
